import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth'
import { Skeleton } from '@/components/ui/loader'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { session, profile, isLoading } = useAuthStore()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center bg-[var(--surface-page)]">
        <div className="w-64 space-y-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
    )
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Force password change if onboarded with a temp password. The target moved
  // to /settings/password in phase 2; the legacy path still resolves (it is a
  // redirect in the router), and it is excluded here so a user who arrives on it
  // is handed to the redirect instead of being bounced in a loop.
  const needsPasswordChange = (profile as { requires_password_change?: boolean } | null)
    ?.requires_password_change
  const onPasswordRoute =
    location.pathname === '/settings/password' || location.pathname === '/profile/change-password'
  if (needsPasswordChange && !onPasswordRoute) {
    return <Navigate to="/settings/password" replace />
  }

  return <>{children}</>
}
